import Vue from 'vue';
import { debounce } from 'lodash-es';
import { gsap } from 'gsap';

Vue.component('faq-component', {
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            userInput: '',
            searchQuery: '',
            faqItems: [],
        };
    },

    computed: {
        filteredData() {
            if (this.searchQuery === '') {
                return this.data;
            }

            const filtered = {};

            for (let i = 0; i < Object.keys(this.data).length; i++) {
                const category = Object.keys(this.data)[i];

                filtered[category] = this.data[category].filter((item) => {
                    if (!item.question || !item.answer) {
                        return false;
                    }

                    if (
                        (item.question.indexOf(this.searchQuery) > -1 || item.answer.indexOf(this.searchQuery) > -1)
                        || (item.keywords && item.keywords.includes(this.searchQuery) > -1)
                    ) {
                        return item;
                    }

                    return false;
                });
            }

            return filtered;
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        console.log(this.data);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleFaq(event) {
            const faqBlock = event.currentTarget.parentElement;
            const faqAnswer = event.currentTarget.nextElementSibling;

            if (faqBlock.classList.contains('active')) {
                faqBlock.classList.remove('active');
                gsap.to(faqAnswer, 0.4, {
                    height: 0,
                    ease: 'Quad.easeOut',
                });
            } else {
                faqBlock.classList.add('active');
                gsap.to(faqAnswer, 0.8, {
                    height: 'auto',
                    ease: 'power2.out',
                });
            }
        },

        debounceInput: debounce(function(e) {
            if (!e || !e.target) {
                return;
            }

            this.searchQuery = e.target.value;
        }, 250),
    },
});
